export default __webpack_public_path__ + "static/pointTwoSelected-0d36e3bf5a634340f861327395e81bfa.png";